import pinia from "@/plugins/pinia";
import { useMenuStateStore } from "@/store/menu-state";
import { useRequestDataStore } from "@/store/request-data";
import { BaseMenuEntry } from "./base-menu-entry";

export class MeasuresMenuEntry extends BaseMenuEntry
{
    protected menuStateStore = useMenuStateStore(pinia);
    protected requestDataStore = useRequestDataStore(pinia);

    public getPicto() : string
    {
        return require("@/assets/pictos/menu-entries/05-measures.svg");
    }

    public isEnabled() : boolean
    {
        return this.requestDataStore.hasDosages;
    }

    public isValid() : boolean
    {
        // Valid if there is at least a single measure
        return this.requestDataStore.hasSamples;
    }

    public isValidated() : boolean
    {
        // If there is at least a single measure, implicitly mark the item as validated
        if (this.isValid()) {
            return true;
        }

        // Validated by user
        return this.menuStateStore.measuresValidated;
    }

    public toggleValidation() : void
    {
        this.menuStateStore.measuresValidated = !this.menuStateStore.measuresValidated;
    }
}
